import styled from '@emotion/styled'

import media from '../../../common/MediaQueries'

const TradingListStyled = styled.ul`
  display: flex;
  flex-wrap: wrap;
  margin: 0 -4rem;
`

const TradingListItemStyled = styled.li`
  display: flex;
  width: 100%;
  padding: 0 4rem 4.125rem;

  @media ${media.tablet} {
    flex-basis: calc(100% / 3);
    max-width: calc(100% / 3);
    padding: 0 4rem 4rem;
  }
`

export { TradingListStyled, TradingListItemStyled }
